import type { TaroNode } from './node'
export const eventSource = new Map<string | undefined | null, TaroNode>()
